import apiClient from 'services/axios'
import { showResponseMessage } from './message'

const PROJECTS_RESOURCE = 'api/projects'

const getIntlMessage = (intl, id, defaultMessage) =>
  intl?.formatMessage ? intl.formatMessage({ id, defaultMessage }) : defaultMessage

const normalizeResource = resource => String(resource || '').replace(/^\/+|\/+$/g, '')

export const isProjectsResource = resource => normalizeResource(resource) === PROJECTS_RESOURCE

const isPublishedJobAd = value => value === true || value === 1 || value === '1' || value === 'true'

const hasPublishedAdsInProjectItem = projectItem => {
  if (Number(projectItem?.onlineJobAdsCounter || 0) > 0) {
    return true
  }

  if (Array.isArray(projectItem?.jobAds)) {
    return projectItem.jobAds.some(jobAd => isPublishedJobAd(jobAd?.pubblicato))
  }

  return false
}

const showDeleteBlockedMessage = intl => {
  showResponseMessage({
    error: true,
    message: getIntlMessage(
      intl,
      'project.delete_blocked_published_ads',
      'Non puoi eliminare la ricerca: esiste almeno un annuncio pubblicato attivo collegato.',
    ),
  })
}

export const canDeleteProjectWithoutPublishedAds = async ({ projectId, projectItem, intl }) => {
  if (!projectId) {
    return true
  }

  if (hasPublishedAdsInProjectItem(projectItem)) {
    showDeleteBlockedMessage(intl)
    return false
  }

  try {
    const itemsPerPage = 50
    const maxPages = 20

    const scanAdsPages = async (page = 1, scannedItems = 0, totalItems = null) => {
      if (page > maxPages) {
        return true
      }

      const response = await apiClient.get('/api/job_ads', {
        params: {
          project: projectId,
          page,
          itemsPerPage,
        },
      })

      const ads = response?.data?.['hydra:member'] || []

      if (ads.some(ad => isPublishedJobAd(ad?.pubblicato))) {
        return false
      }

      const nextScannedItems = scannedItems + ads.length
      const responseTotalItems = Number(response?.data?.['hydra:totalItems'] || 0)
      const nextTotalItems = Number.isFinite(responseTotalItems) ? responseTotalItems : totalItems

      if (ads.length === 0) {
        return true
      }

      if (nextTotalItems !== null && nextScannedItems >= nextTotalItems) {
        return true
      }

      return scanAdsPages(page + 1, nextScannedItems, nextTotalItems)
    }

    const canDelete = await scanAdsPages()
    if (!canDelete) {
      showDeleteBlockedMessage(intl)
      return false
    }

    return true
  } catch (error) {
    showResponseMessage({
      error: true,
      message: getIntlMessage(
        intl,
        'project.delete_check_published_ads_error',
        'Impossibile verificare gli annunci pubblicati del progetto. Riprova tra qualche istante.',
      ),
    })
    return false
  }
}
